
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.77 19a5.77 5.77 0 110 11.538A5.77 5.77 0 015.77 19zM25 19a5.77 5.77 0 110 11.538A5.77 5.77 0 0125 19zm19.23 0a5.77 5.77 0 110 11.538 5.77 5.77 0 010-11.538z","fill":"#979797","fill-rule":"evenodd"}})])
          )
        }
      }
    